import createClient from "./createClient";
export default createClient("/api/seller-app");
